import { mapCartItem } from "./map-cart-item.mjs";
import { toNonNullable } from "../../utils/collections.mjs";
import { useState } from "#imports";
export function useStoredCart() {
  const orderSource = useState("source", () => "");
  const validCart = useState("valid-cart", () => false);
  const hasInvalidItems = useState("has-valid-items", () => false);
  const isPendingCart = useState("is-pending-cart", () => false);
  const isFetchingCart = useState("is-fetching-cart", () => false);
  const paymentFetching = useState("is-fetching-payment", () => false);
  const cartState = useState("cart", () => ({
    cartId: "",
    items: [],
    total: 0,
    subtotal: 0,
    shippingFees: void 0,
    address: null,
    hasInvalidItems: false,
    itemCount: 0,
    discounts: [],
    appliedCoupon: null,
    appliedRewardPoints: void 0,
    discount: null,
    iframeUrl: null
  }));
  function getCartItem(sku) {
    return cartState.value.items.find((i) => sku === i.sku);
  }
  function mapCartState(cart) {
    if (!cart) {
      return cartState.value;
    }
    return {
      cartId: cart.id?.toString() || "",
      total: cart.prices?.grand_total?.value ?? cartState.value.total ?? 0,
      subtotal: cart.prices?.subtotal_including_tax?.value ?? cartState.value.subtotal ?? 0,
      // discounts: toNonNullable(cart.prices?.discounts).map(d => ({ value: d.amount.value ?? 0, label: d.label })) ?? [],
      items: (cart.items ? toNonNullable(cart.items).map(mapCartItem) : cartState.value.items) ?? [],
      address: cart.addresses?.[0] || cartState.value.address || null,
      shippingFees: cart.addresses?.[0]?.selected_shipping_method?.amount.value ?? cartState.value.shippingFees,
      hasInvalidItems: cart.items?.some((item) => {
        if (!item) {
          return;
        }
        const cartItem = mapCartItem(item);
        return !cartItem.stock || cartItem.quantity > cartItem.stock;
      }),
      itemCount: cart.total_quantity ?? cartState.value.itemCount ?? 0,
      discounts: toNonNullable(cart.prices?.discounts).map((d) => ({
        value: d.amount.value ?? 0,
        label: d.label
      })) ?? [],
      /** the promocode applied to the cart */
      appliedCoupon: cart?.applied_coupons === null ? null : cart?.applied_coupons?.[0]?.code || cartState.value.appliedCoupon || void 0,
      /** the discount value after applying the promocode */
      discount: cart.prices?.discounts ? cart.prices.discounts[0]?.amount : null,
      appliedRewardPoints: cart?.applied_reward_points === null ? null : cart?.applied_reward_points ? {
        money: cart?.applied_reward_points?.money?.value || 0,
        points: cart?.applied_reward_points?.points || 0
      } : cartState.value?.appliedRewardPoints,
      iframeUrl: null
      //cart?.acceptIframeUrl ?? null,
    };
  }
  function patchCartState(newState) {
    Object.keys(newState).forEach((key) => {
      cartState.value[key] = newState[key];
    });
  }
  return {
    cartState,
    orderSource,
    validCart,
    hasInvalidItems,
    isPendingCart,
    getCartItem,
    patchCartState,
    mapCartState,
    paymentFetching,
    isFetchingCart
  };
}
